// Employerdb.jsx
import React, { useState } from "react";
import Navbar from "./Navbar";

const Employerdb = () => {
  return (
    <div className="flex flex-col h-screen z-index: 10">
      {/* Navbar */}
      <Navbar></Navbar>
      {/* ---------------------------------------------------Main Page-------------------------------------------------------------- */}
      <div className="p-6 bg-white">
        <div className="grid gap-6 mt-8 z-index:10">
          {/* Job Posting Section */}
          <div className="p-6 bg-gray-200 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-2">Profile</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 sm:grid-cols-2 gap-4 mt-4">
              <div className="bg-blue-200 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Profile Performance</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-medium text-gray-700">Search appearances:</span>
                      <span className="text-2xl font-semibold text-blue-600">49</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-medium text-gray-700">Recruiter actions:</span>
                      <span className="text-2xl font-semibold text-blue-600">27</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-100 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Location</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Bengaluru: <span className="text-blue-600 font-semibold">(2948)</span>
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Pune: <span className="text-blue-600 font-semibold">(2930)</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-blue-200 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Company Type</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Foreign MNC: <span className="text-blue-600 font-semibold">(1376)</span>
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Indian MNC: <span className="text-blue-600 font-semibold">(603)</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Resume Search Section */}
          <div className="p-6 bg-gray-200 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-2">Resume Search</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 sm:grid-cols-2 gap-4 mt-4">
              <div className="bg-blue-200 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Recruitment Specialist</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Remote / Onsite: <span className="text-blue-600 font-semibold">(₹30,000 - ₹50,000 a month)</span>
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Benefits: <span className="text-blue-600 font-semibold">(Food provided, Work from home)</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional sections */}
              <div className="bg-gray-100 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">AI Powered Search</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Search <span className="text-blue-600 font-semibold">candidates</span> using AI.
                      </span>
                    </div>
                    <button className="px-6 py-3 bg-[#0077B5] text-white font-medium rounded-md shadow hover:bg-[#0077B5] transition duration-300">
                      Bagwa AI
                    </button>
                  </div>
                </div>
              </div>
              <div className="bg-blue-200 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Human Resouce Management</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Onsite: <span className="text-blue-600 font-semibold">(₹20,000 - ₹40,000 a month)</span>
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Benefits: <span className="text-blue-600 font-semibold">(Flexible schedule)</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Account Section */}
          <div className="p-6 bg-gray-200 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold mb-2">Account Utilization</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 sm:grid-cols-2 gap-4 mt-4">
              <div className="bg-blue-200 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Profile Searched</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-medium text-gray-700">Searched Candidate:</span>
                      <span className="text-2xl font-semibold text-blue-600">150</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-medium text-gray-700">Recruiter actions:</span>
                      <span className="text-2xl font-semibold text-blue-600">20</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-100 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">AI Powered Help</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        candidate fetched: <span className="text-blue-600 font-semibold">(2000)</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-blue-200 flex justify-center items-center rounded-md transition-transform transform hover:scale-105 hover:bg-[#0077B5] p-4">
                <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Candidate Account</h3>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">Bengaluru:
                        <span className="text-blue-600 font-semibold">(1376)</span>
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-lg font-medium text-gray-700">
                        Pune: <span className="text-blue-600 font-semibold">(603)</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employerdb;
